import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import _ from 'lodash';

import { Button, LinearProgress as LoadingOverlay } from '@material-ui/core';
import BeatLoader from 'react-spinners/BeatLoader';

import { getAllTimezones, getTimezone } from "countries-and-timezones"

import {
  DataGridPro, useGridApiRef, GridFooter, GridFilterInputValue, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton,
  GridColumnMenuContainer, SortGridMenuItems, GridFilterMenuItem, CustomUserItem, gridColumnsTotalWidthSelector
} from '@mui/x-data-grid-pro';

import Print from './Print';
import Export from './Export';
import Create from './Create';
import Update from './Update';

import { useAppContext } from '../../../../Context/App/Provider';
import { get, create, update, remove, updateViews, generateLicense } from '../../../../Functions/admin';
import { useAdminContext } from '../../../../Context/Admin/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { colors, roles, useStateWithCallback, devicesTypeValues, toastTimerValue } from '../../../../Shared/utils';
import { changeAdminColumns, changeSettings, activeGridFilter, setLocationGridValues, translatedGridFilters, getTimeAsZDateTime, getRandomPassword } from '../../../../Functions/utils';

import { updateLicenseColumnsOrder, updateSavedLicenses } from '../../../../Functions/user';
import { decodeHTMLEntities } from '../../../../Functions/utils';

import '../Admin.css';
import '../../../SweetAlert.css'
import { addDays } from 'date-fns';


export default function LicensesList() {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();

  const [{ settings, user }, appDispatch] = useAppContext();
  const [{ pickers, selected }, dispatch] = useReportingContext();
  const [{ groupsLocationsStatus, deploymentsStatus, scenariosStatus }, eventDispatch] = useEventContext();

  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filterModel, setFilterModel] = useState({
    items: [],
    linkOperator: "and"
  });

  const [model, setModel] = useStateWithCallback({ filtered: null, selected: [] });
  const [sortModel, setSortModel] = useState([]);
  const [currentMovedColumns, setCurrentMovedColumns] = useState([]);

  const [selectedLicense, setSelectedLicense] = useState(null);
  const [modeLicenses, setModeLicenses] = useState(
    settings.modeLicense === 'all_licenses' ||
      settings.modeLocation === 'my_licenses' ? settings.modeLicense : 'all_licenses'
  );


  const CustomColumnMenu = (props) => {
    const { hideMenu, currentColumn, ...other } = props;

    return (
      <GridColumnMenuContainer
        hideMenu={hideMenu}
        currentColumn={currentColumn}
        {...props}
      >
        <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
        <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
      </GridColumnMenuContainer>
    );
  }

  const timeZones = getAllTimezones();
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };

  const [highlightedRow, setHighlightedRow] = useState(null);

  const [reordering, setReordering] = useState(null);
  const [reorderedColumn, setReorderedColumn] = useState("");

  const [oldIndex, setOldIndex] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);

  const [loadedColumnsFromDatabase, setLoadedColumnsFromDatabase] = useState(false);
  const [licenseColumnsFromDatabase, setLicenseColumnsFromDatabase] = useState({});

  useEffect(() => {
    if (!loadedColumnsFromDatabase) {
      setLoadedColumnsFromDatabase(true);

      const licenseColumnsOrder = user.licenseColumnsOrder ? JSON.parse(user.licenseColumnsOrder) : {};

      const allLicenseColumns = {
        Enabled: { hide: false, order: 1, width: 100 },                 //  slider for license.enabled
        id: { hide: false, order: 2, width: 100 },                       //  internal id.
        Product_id: { hide: false, order: 3, width: 140 },                    //  picto for MacRestorer/SDS/SBAR....
        Customer_id: { hide: false, order: 4, width: 140 },              //  customer Id - set by FAE
        Group_name: { hide: false, order: 5, width: 200 },                   //  group name
        Location_id: { hide: false, order: 6, width: 300 },                //  Location_id
        Label: { hide: false, order: 7, width: 300 },                //  location name
        DI_name: { hide: false, order: 8, width: 300 },                //  DI_name
        Server_Name: { hide: false, order: 9, width: 300 },                //  server name
        Serial: { hide: false, order: 10, width: 200 },                  //  host system S/N
        Motherboard_serial_number: { hide: false, order: 11, width: 260 },      //  host MB S/N        
        UUID: { hide: false, order: 12, width: 300 },                   //  host UUID      
        U_name: { hide: false, order: 13, width: 200 },                //  creator name - 1st activator
        CreationDate: { hide: false, order: 14, width: 200 },           //  creation date
        registerDate: { hide: true, order: 15, width: 300 },           //  register date
        FirstCheckDate: { hide: false, order: 16, width: 300 },         //  1st check date
        LastCheckDate: { hide: false, order: 17, width: 300 },          //  last check date
        LastCheckResult: { hide: false, order: 18, width: 300 },        //  last check result
        NextCheckDate: { hide: false, order: 19, width: 300 },        //  next check date
        Duration: { hide: true, order: 20, width: 140 },               //  duration
        durationConsumed: { hide: true, order: 21, width: 300 },       //  duration consumed
        durationRemaining: { hide: true, order: 22, width: 300 },      //  duration remaining
        Nb_processes: { hide: true, order: 23, width: 140 },            //  nbProcesses
        nbProcessesConsumed: { hide: true, order: 24, width: 300 },    //  nbProcessesConsumed
        nbProcessesRemaining: { hide: true, order: 25, width: 300 },   //  nbProcessesRemaining
        lastRenewDate: { hide: true, order: 26, width: 300 },          //  last renew date
        GracePeriod: { hide: false, order: 27, width: 300 },            //  grace period
        gracePeriodConsumed: { hide: true, order: 28, width: 300 },    //  grace period consumed                
        actions: { hide: false, order: 29, width: 100 }
      }

      for (const key of Object.keys(allLicenseColumns)) {
        if (licenseColumnsOrder[key]) {
          allLicenseColumns[key] = licenseColumnsOrder[key];
        }
      }

      const orderedKeys = Object.keys(allLicenseColumns)
        .sort((a, b) => {
          return allLicenseColumns[a].order > allLicenseColumns[b].order ? 1 : -1;
        });

      let i = 1;
      for (const key of orderedKeys) {
        allLicenseColumns[key].order = i;
        i++;
      }
      setLicenseColumnsFromDatabase(allLicenseColumns);
    }
  }, [loadedColumnsFromDatabase]);


  useEffect(() => {
    apiRef.current.subscribeEvent('columnHeaderDragStart', (params) => {
      setReordering(true);
      setReorderedColumn("");
      setOldIndex(null);
      setTargetIndex(null);
    });

    apiRef.current.subscribeEvent('columnHeaderDragEnd', (params) => {
      setReordering(false);
    });
  }, [apiRef]);


  useEffect(() => {
    if (reordering === false) {
      changeColumnsOrder(reorderedColumn, oldIndex, targetIndex);
      setReordering(null);
    }
  }, [reordering]);



  let columns = [];
  if (licenseColumnsFromDatabase.id) {

    columns = [ // default visible width: 1650
      {
        field: 'id',
        headerName: 'ID',
        hide: licenseColumnsFromDatabase.id ? licenseColumnsFromDatabase.id.hide : false,
        filterable: false,
        width: licenseColumnsFromDatabase.id ? licenseColumnsFromDatabase.id.width : 100
      },
      {
        // sortable: false,
        field: 'Enabled',
        type: 'activeFilter',
        hide: licenseColumnsFromDatabase.enabled ? licenseColumnsFromDatabase.enabled.hide : false,
        width: licenseColumnsFromDatabase.enabled ? licenseColumnsFromDatabase.enabled.width : 140,
        headerName: t('admin.licenses.columns.active'),

        renderCell: ({ row }) => {
          const icon = (
            <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
              <circle r={3.5} cx={5} cy={5} />
            </svg>
          );

          return (
            <Switch
              disabled={loading}
              checked={row.Enabled}
              onChange={() => toggleActivated(row)}
              offHandleColor="#888" onHandleColor="#080"

              checkedIcon={null} uncheckedIcon={null}
              checkedHandleIcon={icon} uncheckedHandleIcon={icon}
            />
          );
        }
      },
      {
        /*
            1 : SDS
            2 : MacRestorer
            3 : Chromebook solution
            4 : Windows Diagnostics
            5 : SBAR
            6 : OnDevice 

        */
        sortable: true,
        field: 'Product_id',
        type: 'singleSelect',
        hide: licenseColumnsFromDatabase.type ? licenseColumnsFromDatabase.type.hide : false,
        width: licenseColumnsFromDatabase.type ? licenseColumnsFromDatabase.type.width : 140,
        headerName: t('admin.licenses.columns.type'),
        valueOptions: [
          'SDS',
          'MacRestorer',
          'Chromebook solution',
          'Windows Diagnostics',
          'SBAR',
          'OnDevice'
        ],
        valueGetter: (params) => {
          let value = "";
          switch (params.Product_id) {
            case 1: {
              value = t('admin.licenses.type_SDS');
              break;
            }
            case 2: {
              value = t('admin.licenses.type_MacRestorer');
              break;
            }
            case 3: {
              value = t('admin.licenses.type_Chromebook_solution');
              break;
            }
            case 4: {
              value = t('admin.licenses.type_Windows_Diagnostics');
              break;
            }
            case 5: {
              value = t('admin.licenses.type_SBAR');
              break;
            }
            case 6: {
              value = t('admin.licenses.type_OnDevice');
              break;
            }
            default: {
              value = "";
              break;
            }
          }
          return value;
        },
        renderCell: ({ row }) => {
          switch (row.Product_id) {
            case 1:
            case "1": {
              return (
                <span
                  className="material-icons"
                  title={t('admin.licenses.type_SDS')}
                  style={{ height: 'auto', cursor: 'help' }}
                >laptop
                </span>
              );
              break;
            }
            case 2:
            case "2": {
              return (
                <span
                  className="material-icons"
                  title={t('admin.licenses.type_MacRestorer')}
                  style={{ height: 'auto', cursor: 'help' }}
                >apple
                </span>
              );
              break;
            }
            case 3:
            case "3": {
              return (
                <span
                  className="material-icons"
                  title={t('admin.licenses.type_Chromebook_solution')}
                  style={{ height: 'auto', cursor: 'help' }}
                >LaptopChromebook
                </span>
              );
              break;
            }
            case 4:
            case "4": {
              return (
                <span
                  className="material-icons"
                  title={t('admin.licenses.type_Windows_Diagnostics')}
                  style={{ height: 'auto', cursor: 'help' }}
                >LaptopWindows
                </span>
              );
              break;
            }
            case 5:
            case "5": {
              return (
                <span
                  className="material-icons"
                  title={t('admin.licenses.type_SBAR')}
                  style={{ height: 'auto', cursor: 'help' }}
                >laptop
                </span>
              );
              break;
            }
            case 6:
            case "6": {
              return (
                <span
                  className="material-icons"
                  title={t('admin.licenses.type_OnDevice')}
                  style={{ height: 'auto', cursor: 'help' }}
                >laptop
                </span>
              );
              break;
            }
            default: {
              return (
                <></>
              );
              break;
            }
          }
        }
      },

      {
        field: 'Customer_id',
        hide: licenseColumnsFromDatabase.Customer_id ? licenseColumnsFromDatabase.Customer_id.hide : false,
        width: licenseColumnsFromDatabase.Customer_id ? licenseColumnsFromDatabase.Customer_id.width : 100,
        headerName: t('admin.licenses.columns.customerId')
      },
      {
        field: 'Group_name',
        hide: licenseColumnsFromDatabase.Group_name ? licenseColumnsFromDatabase.Group_name.hide : false,
        width: licenseColumnsFromDatabase.Group_name ? licenseColumnsFromDatabase.Group_name.width : 100,
        headerName: t('admin.licenses.columns.group')
      },
      {
        field: 'Location_id',
        hide: licenseColumnsFromDatabase.Location_id ? licenseColumnsFromDatabase.Location_id.hide : false,
        width: licenseColumnsFromDatabase.Location_id ? licenseColumnsFromDatabase.Location_id.width : 100,
        headerName: t('admin.licenses.columns.locationId')
      },
      {
        field: 'Label',
        hide: licenseColumnsFromDatabase.Label ? licenseColumnsFromDatabase.Label.hide : false,
        width: licenseColumnsFromDatabase.Label ? licenseColumnsFromDatabase.Label.width : 300,
        headerName: t('admin.licenses.columns.location')
      },
      {
        field: 'DI_name',
        hide: licenseColumnsFromDatabase.DI_name ? licenseColumnsFromDatabase.DI_name.hide : false,
        width: licenseColumnsFromDatabase.DI_name ? licenseColumnsFromDatabase.DI_name.width : 300,
        headerName: t('admin.licenses.columns.databaseName')
      },
      {
        field: 'Server_Name',
        hide: licenseColumnsFromDatabase.Server_Name ? licenseColumnsFromDatabase.Server_Name.hide : false,
        width: licenseColumnsFromDatabase.Server_Name ? licenseColumnsFromDatabase.Server_Name.width : 300,
        headerName: t('admin.licenses.columns.serverName')
      },
      {
        field: 'Serial',
        hide: licenseColumnsFromDatabase.Serial ? licenseColumnsFromDatabase.Serial.hide : false,
        width: licenseColumnsFromDatabase.Serial ? licenseColumnsFromDatabase.Serial.width : 100,
        headerName: t('admin.licenses.columns.serial')
      },
      {
        field: 'Motherboard_serial_number',
        hide: licenseColumnsFromDatabase.Motherboard_serial_number ? licenseColumnsFromDatabase.Motherboard_serial_number.hide : false,
        width: licenseColumnsFromDatabase.Motherboard_serial_number ? licenseColumnsFromDatabase.Motherboard_serial_number.width : 100,
        headerName: t('admin.licenses.columns.motherboard_serial')
      },
      {
        field: 'UUID',
        hide: licenseColumnsFromDatabase.UUID ? licenseColumnsFromDatabase.UUID.hide : false,
        width: licenseColumnsFromDatabase.UUID ? licenseColumnsFromDatabase.UUID.width : 100,
        headerName: t('admin.licenses.columns.uuid')
      },
      {
        field: 'U_name',
        hide: licenseColumnsFromDatabase.U_name ? licenseColumnsFromDatabase.U_name.hide : false,
        width: licenseColumnsFromDatabase.U_name ? licenseColumnsFromDatabase.U_name.width : 100,
        headerName: t('admin.licenses.columns.creator')
      },
      {
        field: 'CreationDate',
        hide: licenseColumnsFromDatabase.CreationDate ? licenseColumnsFromDatabase.CreationDate.hide : false,
        width: licenseColumnsFromDatabase.CreationDate ? licenseColumnsFromDatabase.CreationDate.width : 100,
        headerName: t('admin.licenses.columns.creationDate'),
        align: 'left',
        headerAlign: 'left',
        type: 'date',
        renderCell: ({ row }) => {
          if (row && row.CreationDate && row.CreationDate !== '') {
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: '2-digit'
            };

            const lastTxt = new Date(row.CreationDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
            return (
              <div>
                {lastTxt}
              </div>
            )
          }
          return (
            <div>
              ...
            </div>
          )
        }
      },
      {
        field: 'Duration',
        hide: licenseColumnsFromDatabase.Duration ? licenseColumnsFromDatabase.Duration.hide : false,
        width: licenseColumnsFromDatabase.Duration ? licenseColumnsFromDatabase.Duration.width : 100,
        headerName: t('admin.licenses.columns.duration')
      },
      {
        field: 'Nb_processes',
        hide: licenseColumnsFromDatabase.Nb_processes ? licenseColumnsFromDatabase.Nb_processes.hide : false,
        width: licenseColumnsFromDatabase.Nb_processes ? licenseColumnsFromDatabase.Nb_processes.width : 100,
        headerName: t('admin.licenses.columns.nbProcesses')
      },
      {
        field: 'GracePeriod',
        hide: licenseColumnsFromDatabase.GracePeriod ? licenseColumnsFromDatabase.GracePeriod.hide : false,
        width: licenseColumnsFromDatabase.GracePeriod ? licenseColumnsFromDatabase.GracePeriod.width : 100,
        headerName: t('admin.licenses.columns.gracePeriod'),
        renderCell: ({ row }) => {
          // console.log("472 - row=", row);
          let alert = 0;

          if (row.LastCheckDate) {
            let percent = 0;
            let currentDateCheckTmp = new Date();
            let startDateCheckTmp;
            let finalDateCheckTmp;

            if (row.LastCheckResult == 0) {
              startDateCheckTmp = addDays(new Date(row.LastCheckDate), row.Check_delay);
              finalDateCheckTmp = addDays(new Date(row.LastCheckDate), row.Check_delay + row.GracePeriod);
            }
            else {
              startDateCheckTmp = addDays(new Date(row.LastCheckDate), 0);
              finalDateCheckTmp = addDays(new Date(row.LastCheckDate), row.GracePeriod);
            }

            let errorValue = 100 * (finalDateCheckTmp - currentDateCheckTmp) / (finalDateCheckTmp - startDateCheckTmp);
            // console.log("490 - errorValue=", errorValue);

            if (errorValue <= 0)
              alert = 2;
            else if (errorValue <= 34)
              alert = 1

            if (errorValue < 0)
              percent = 0.00;
            else if (errorValue > 100)
              percent = 100.00;
            else
              percent = Number.parseFloat(errorValue).toFixed(2);

            // console.log("497 - %=", 100 * (finalDateCheckTmp - currentDateCheckTmp) / (finalDateCheckTmp - startDateCheckTmp));
            if (alert == 2) {
              return (
                <div style={{ color: '#ff0000' }}>
                  {row.GracePeriod} ({percent}%)
                </div>
              )
            }

            if (alert == 1) {
              return (
                <div style={{ color: '#ffa600' }}>
                  {row.GracePeriod} ({percent}%)
                </div>
              )
            }

            if (alert == 0) {
              return (
                <div>
                  {row.GracePeriod} ({percent}%)
                </div>
              )
            }

          }
          return (
            <div>
              ...
            </div>
          )
        }
      },

      {
        field: 'FirstCheckDate',
        hide: licenseColumnsFromDatabase.FirstCheckDate ? licenseColumnsFromDatabase.FirstCheckDate.hide : false,
        width: licenseColumnsFromDatabase.FirstCheckDate ? licenseColumnsFromDatabase.FirstCheckDate.width : 100,
        headerName: t('admin.licenses.columns.firstCheckDate'),
        align: 'left',
        headerAlign: 'left',
        type: 'date',
        renderCell: ({ row }) => {
          if (row && row.FirstCheckDate && row.FirstCheckDate !== '') {
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: '2-digit'
            };

            const lastTxt = new Date(row.FirstCheckDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
            return (
              <div>
                {lastTxt}
              </div>
            )
          }
          return (
            <div>
              ...
            </div>
          )
        }
      },
      {
        field: 'LastCheckDate',
        hide: licenseColumnsFromDatabase.LastCheckDate ? licenseColumnsFromDatabase.LastCheckDate.hide : false,
        width: licenseColumnsFromDatabase.LastCheckDate ? licenseColumnsFromDatabase.LastCheckDate.width : 100,
        headerName: t('admin.licenses.columns.lastCheckDate'),
        align: 'left',
        headerAlign: 'left',
        type: 'date',
        renderCell: ({ row }) => {
          if (row && row.LastCheckDate && row.LastCheckDate !== '') {
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: '2-digit'
            };

            const lastTxt = new Date(row.LastCheckDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);

            let alert = 0;
            if (row.LastCheckResult == 0) {
              let dateCheckTmp1 = addDays(new Date(row.LastCheckDate), row.Check_delay);
              if (dateCheckTmp1 < new Date()) {
                alert = 1;
              }

              let dateCheckTmp2 = addDays(new Date(row.LastCheckDate), row.Check_delay + row.GracePeriod);
              if (dateCheckTmp2 < new Date()) {
                alert = 2;
              }
            }
            else {
              let dateCheckTmp1 = addDays(new Date(row.LastCheckDate), row.GracePeriod);
              if (dateCheckTmp1 < new Date()) {
                alert = 1;
              }

              let dateCheckTmp2 = new Date(row.LastCheckDate);
              if (dateCheckTmp2 < new Date()) {
                alert = 2;
              }
            }

            if (alert == 2) {
              return (
                <div style={{ color: '#ff0000' }}>
                  <span
                    className="material-icons"
                    style={{ color: '#ff0000', verticalAlign: 'text-bottom' }}
                  >
                    warning_amber
                    &nbsp;

                  </span>
                  {lastTxt}
                </div>
              )
            }

            if (alert == 1) {
              return (
                <div style={{ color: '#ffa600' }}>
                  <span
                    className="material-icons"
                    style={{ color: '#ffa600', verticalAlign: 'text-bottom' }}
                  >
                    warning_amber
                    &nbsp;

                  </span>
                  {lastTxt}
                </div>
              )
            }

            if (alert == 0) {
              return (
                <div style={{ color: 'green' }}>
                  {lastTxt}
                </div>
              )
            }

            return (
              <div>
                <span >
                  {lastTxt}
                </span>
              </div>
            )
          }
          return (
            <div>
              ...
            </div>
          )
        }
      },

      {
        field: 'LastCheckResult',
        hide: licenseColumnsFromDatabase.LastCheckResult ? licenseColumnsFromDatabase.LastCheckResult.hide : false,
        width: licenseColumnsFromDatabase.LastCheckResult ? licenseColumnsFromDatabase.LastCheckResult.width : 100,
        headerName: t('admin.licenses.columns.lastCheckResult'),
        align: 'left',
        headerAlign: 'left',
        // type: 'date',
        renderCell: ({ row }) => {

          if (row.LastCheckResult) {
            const errorText = t(`license_error_codes.${row.LastCheckResult}`);
            if (row.LastCheckResult == 0) {
              return (
                <div style={{ color: 'green' }}>
                  {errorText}
                </div>
              );
            }

            return (
              <div style={{ color: '#ff0000' }}>
                <span
                  className="material-icons"
                  style={{ color: '#ff0000', verticalAlign: 'text-bottom' }}
                >
                  warning_amber
                  &nbsp; 
                </span>
                {errorText}
              </div>
            );
          }
        }
      },

      {
        field: 'NextCheckDate',
        hide: licenseColumnsFromDatabase.NextCheckDate ? licenseColumnsFromDatabase.NextCheckDate.hide : false,
        width: licenseColumnsFromDatabase.NextCheckDate ? licenseColumnsFromDatabase.NextCheckDate.width : 100,
        headerName: t('admin.licenses.columns.nextCheckDate'),
        align: 'left',
        headerAlign: 'left',
        type: 'date',
        renderCell: ({ row }) => {
          if (row && row.LastCheckDate && row.LastCheckDate !== '') {

            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: '2-digit'
            };

            const nextDateCheckTmp = addDays(new Date(row.LastCheckDate), row.Check_delay);
            const nextTxt = new Date(nextDateCheckTmp).toLocaleDateString(settings.lang ? settings.lang : 'en', options);

            return (
              <div>
                <span >
                  {nextTxt}
                </span>
              </div>
            )
          }
          return (
            <div>
              ...
            </div>
          )
        }
      },

      {
        field: 'actions',
        headerName: 'Actions',
        hide: licenseColumnsFromDatabase.actions.hide,
        width: Math.max(140, licenseColumnsFromDatabase.actions.width),

        sortable: false,
        filterable: false,

        align: 'right',
        headerAlign: 'right',

        renderCell: ({ row }) => {

          let forceDisabled = true;
          if (user.roleId === roles.dashboardSuperAdmin)
            forceDisabled = false;

          if (row.FirstCheckDate === null && row.Owner === user.id)
              forceDisabled = false;

          return (
            <div>
              <Button
                disabled={loading}
                title={t('global.generate_license')}
                style={{ minWidth: 'unset' }}
                onClick={(e) => {
                  handleGenerateLicense(row);
                }}
              >
                <span className="material-icons-outlined" style={{ color: '#222' }}>policy</span>
              </Button>

              <Button
                disabled={loading || forceDisabled}
                title={t('global.update')}
                style={{ minWidth: 'unset' }}
                onClick={() => {
                    return setSelectedLicense(row);
                }}
              >
                <span className="material-icons-outlined" style={{ color: '#222' }}>edit</span>
              </Button>

              <Button
                disabled={loading || forceDisabled}
                title={t('global.delete')}
                style={{ minWidth: 'unset' }}
                onClick={() => handleDelete(row)}
              >
                <span className="material-icons-outlined" style={{ color: '#f22' }}>delete</span>
              </Button>
            </div>
          )
        }
      },
    ] // Keep columns order between sessions      
      .sort((a, b) => {
        if (licenseColumnsFromDatabase[a.field] && licenseColumnsFromDatabase[b.field])
          return licenseColumnsFromDatabase[a.field].order - licenseColumnsFromDatabase[b.field].order;
        return -1;
      });
  }



  const toggleActivated = (lic) => {

    console.log("518 - lic=", lic);

    setLoading(true);
    lic.Enabled = !lic.Enabled;
    const license = { id: lic.id, Enabled: lic.Enabled };

    update({ type: 'license', license }).then(res => {
      setLoading(false);

      console.log("527 - res=", res);

      if (!res.success) {
        lic.Enabled = !lic.Enabled; // revert switch state if error
        return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res, { id: lic.id })), { type: 'error' });
      }
      toast(decodeHTMLEntities(t('admin.licenses.' + (res.license.enabled ? 'activated' : 'deactivated'), { id: lic.id })), { type: 'success' });
    });



    // if (lic.exists) {
    // setLoading(true);

    // loc.Enabled = !loc.Enabled;
    // const license = { id: loc.id, skip: true, Enabled: loc.Enabled };

    // // console.log("445 - update license=", license);

    // update({ type: 'license', license }).then(res => {
    //   setLoading(false);
    //   if (!res.success) {
    //     loc.Enabled = !loc.Enabled; // revert switch state if error
    //     return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res, { name: loc.label })), { type: 'error' });
    //   }
    //   const savedLicenses = selected.licenses;
    //   const newSavedLicenses = savedLicenses.filter(license => license.value !== loc.id);
    //   const savedLicensesChanged = !_.isEqual(savedLicenses, newSavedLicenses);

    //   if (savedLicensesChanged && !loc.Enabled) {
    //     updateSavedLicenses(JSON.stringify(newSavedLicenses));

    //     if (settings.mode === 'modules')
    //       eventDispatch({ groupsLicensesStatus: 'force', deploymentsStatus: 'pending' });
    //     else {
    //       eventDispatch({ groupsLicensesStatus: 'force', scenariosStatus: 'pending' });
    //     }
    //   }
    //   else {
    //     eventDispatch({ groupsLicensesStatus: 'force' });
    //   }

    //   toast(decodeHTMLEntities(t('admin.licenses.' + (res.license.Enabled ? 'activated' : 'deactivated'), { name: loc.label })), { type: 'success' });

    // });
    // }
  };


  const handleDelete = (lic) => {
    // console.log("879 - lic=", lic);   
    

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.licenses.delete.confirm', { id: lic.id }),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      inputValidator: (value) => {
        const newValue = value.replace(/ /g, ' ');
        const newLabel = lic.id.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, loc.label, newValue === loc.label);
        if (newValue != newLabel && value != lic.id && newValue != lic.id) {   // CHECK loc.label === value
          return t('admin.licenses.delete.validation');
        }
        return "";
      },
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
      }
    }).then((value) => {
      // console.log("589 - value=", value);

      if (value && value.isConfirmed) {
        const newValue = value && value.value.replace(/ /g, ' ');
        const newLabel = lic && lic.id && lic.id.replace(/ /g, ' ');

        // console.log("912 - value=", value, newValue, lic.id, newValue === lic.id);
        if (newValue === newLabel || value === lic.id || newValue === lic.id) {   // CHECK loc.label === value
          setLoading(true);

          remove({ type: 'license', id: lic.id }).then(res => {
            setLoading(false);
            if (!res.success) {
              return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res, { id: lic.id })), { type: 'error' });
            }

            setLicenses(licenses.filter(row => row.id !== lic.id));
            toast(decodeHTMLEntities(t('admin.licenses.delete.success', { id: lic.id })), { type: 'success' });
          });
        }
      }
    });
  };

  const handleSortChange = (model) => {
    /* if statement to prevent the infinite loop by confirming model is 
     different than the current sortModel state */
    if (JSON.stringify(model) !== JSON.stringify(sortModel)) {
      setSortModel(model);
    }
  };

  const handleSetModeLicenses = (mode) => {
    setModeLicenses(mode);
    changeSettings(t, 'modeLicense', mode, settings, appDispatch);
    document.querySelector('#modeLicenses').classList.toggle('open');
  };

  const selectedOption = () => {
    if (!selectedLicense) return null;

    // determine if user wants to create or edit a license
    return selectedLicense.id ? (
      <Update
        licenses={licenses}
        setLicenses={setLicenses}
        selectedLicense={selectedLicense}
        setSelectedLicense={setSelectedLicense}
      />
    ) : (
      <Create
        licenses={licenses}
        setLicenses={setLicenses}
        setSelectedLicense={setSelectedLicense}
      />
    );
  };


  const changeColumnsWidth = (col) => {
    // console.log("629 - changeColumnsWidth=", col);
    const prev = JSON.stringify(licenseColumnsFromDatabase);
    let newLicenseColumns = licenseColumnsFromDatabase;

    if (newLicenseColumns[col.colDef.field]) {
      newLicenseColumns[col.colDef.field].width = col.width;
      const next = JSON.stringify(newLicenseColumns);

      if (prev !== next) {
        updateLicenseColumnsOrder(newLicenseColumns);
        setLicenseColumnsFromDatabase(newLicenseColumns);

        const newUser = {
          ...user,
          licenseColumnsOrder: next
        }
        appDispatch({ user: newUser });
      }
    }
  }


  const changeColumnsVisibility = (col) => {
    // console.log("895 - changeColumnsVisibility=", col);
    const prev = JSON.stringify(licenseColumnsFromDatabase);
    let newLicenseColumns = licenseColumnsFromDatabase;

    if (newLicenseColumns[col.colDef.field]) {
      newLicenseColumns[col.colDef.field].hide = !col.isVisible;
      const next = JSON.stringify(newLicenseColumns);

      if (prev !== next) {
        updateLicenseColumnsOrder(newLicenseColumns);
        setLicenseColumnsFromDatabase(newLicenseColumns);

        const newUser = {
          ...user,
          licenseColumnsOrder: next
        }
        appDispatch({ user: newUser });
      }
    }
  }

  const changeColumnsOrder = (reorderedColumn, oldIndex, targetIndex) => {
    const prev = JSON.stringify(licenseColumnsFromDatabase);

    let ecart = targetIndex - oldIndex;
    if (ecart > 0)
      ecart = ecart + 0.5;
    else
      ecart = ecart - 0.5;

    let newLicenseColumns = {};
    for (const columnName in licenseColumnsFromDatabase) {
      const column = licenseColumnsFromDatabase[columnName];

      newLicenseColumns[columnName] = licenseColumnsFromDatabase[columnName];

      if (columnName === reorderedColumn)
        newLicenseColumns[columnName].order = newLicenseColumns[columnName].order + ecart;
    }
    const orderedKeys = Object.keys(newLicenseColumns)
      .sort((a, b) => {
        return newLicenseColumns[a].order > newLicenseColumns[b].order ? 1 : -1;
      });

    let i = 1;
    for (const key of orderedKeys) {
      newLicenseColumns[key].order = i;
      i++;
    }
    const next = JSON.stringify(newLicenseColumns);

    if (prev !== next) {
      updateLicenseColumnsOrder(newLicenseColumns);
      setLicenseColumnsFromDatabase(newLicenseColumns);

      const newUser = {
        ...user,
        licenseColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }

    setReordering(null);
    setReorderedColumn("");
    setOldIndex(null);
    setTargetIndex(null);
  }

  const rowsToPrint = () => {
    const filtered = model.filtered ?? licenses;

    // .slice() creates a new array
    const rows = filtered.slice().filter(loc => (
      model.selected.length > 0 ? model.selected.includes(loc.id) : loc.id > 0
    ));

    return rows;
  };

  const updateRowsAndPrint = () => {
    setModel(
      { ...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values()) },
      () => window.print()
    );
  };


  const handleGenerateLicense = (row) => {
    // console.log("86 - row=", row);
    setLoading(true);
    //t('admin.licenses.generate.pleaseWait', '...') + 
    
    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.licenses.generate.pleaseWait', '...'),
      confirmButtonText: t("global.ok"),
      showCancelButton: false,
      showConfirmButton: false,
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class',
        width: '2000px'
      },
      didOpen: function () {
        Swal.showLoading()
      },
      width: '2000px',
      padding: "3em"
    })

    generateLicense({ id: row.id }).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res, { name: row.id })), { type: 'error' });
      }

      // console.log("883 - res=", res);

      Swal.hideLoading();
      Swal.update({
        html: t('admin.licenses.generate.success', { key: res.data }),
        showConfirmButton: true,
      });
    });
  }



  useEffect(() => {
    // console.log("1343 - useEffect... licenses=", licenses);
    document.title = t('admin.licenses.page');

    if (licenses.length === 0) {
      get({ type: 'license' }).then(res => {
        setLoading(false);

        if (!res.success) {
          return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res)), { type: 'error' });
        }

        // console.log("863 -res=", res);
        const newLicenses = [];
        setLicenses(res.licenses.sort(function (a, b) {
          if (a.group && b.group && a.group.toLowerCase() < b.group.toLowerCase()) {
            return -1;
          }
          if (a.group && b.group && b.group.toLowerCase() < a.group.toLowerCase()) {
            return 1;
          }

          if (a.id && b.id && Number(a.id) < Number(b.id)) {
            return -1;
          }
          return 1;
        }));

      });
    }
  }, [t, licenses]);


  // console.log("897 - licenses=", licenses);
  // console.log("898 - columns=", columns);
  // console.log("370 - databV2=", databV2);
  // console.log("383 - sortModel=", sortModel);
  const allColumns = columns; //.concat(newColumns.sort((a, b) => parseInt(a.field) > parseInt(b.field) ? -1 : 1));
  // console.log("900 - allColumns=", allColumns);
  // console.log("1327 - licenses=", licenses);
  // console.log("903 - sortModel=", sortModel);


  const linkOperator = (filterModel && filterModel.items.length > 1) ? (filterModel && filterModel.linkOperator) || "and" : "and";
  const newFilteredRows = _.filter(licenses, row => {

    let keepIt;

    // AND
    if (filterModel && linkOperator === "and") {
      keepIt = true;

      // console.log("906 - filterModel=", filterModel);
      for (const filter of filterModel.items) {

        const values = filter.value && filter.value.split("|");

        switch (filter.operatorValue) {
          case "contains": {
            if (filter.value) {
              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              // console.log("990 - columnElement=", columnElement);

              if (columnElement && columnElement.moduleVersionColumn === true) {

                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {

                    // console.log("998 - value=", value);
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');

                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {

                  // console.log("1017 - row[filter.columnField]=", row["email"]);
                  const found = values.find(value =>
                    row["email"].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {

                  // console.log("1017 - row[filter.columnField]=", row[filter.columnField]);
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          // case "contains": {
          //   if (filter.value && row[filter.columnField] && !row[filter.columnField].toUpperCase().includes(filter.value.toUpperCase()))
          //     keepIt = false;
          //   break;
          // }

          case "equals": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase() !== filter.value.toUpperCase())
            //   keepIt = false;
            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase() === (value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase() === (value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase() === (value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "startsWith": {
            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().startsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "endsWith": {
            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().endsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "isEmpty": {
            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1152 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                // console.log("1157 - row.moduleVersion=", row.moduleVersion);
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null)
                      keepIt = false;
                  }
                };
                if (!isThere)
                  keepIt = false;
              }
              // else
              //   keepIt = false;

            }
            else if (filter.columnField === "owner") {
              let isThere = false;
              if (row["email"] !== '') {
                isThere = true;
                if (row["email"] !== undefined && row["email"] !== null)
                  keepIt = false;
              }
              if (!isThere)
                keepIt = false;
            }
            else {
              let isThere = false;
              if (row[filter.columnField] !== '') {
                isThere = true;
                if (row[filter.columnField] !== undefined && row[filter.columnField] !== null)
                  keepIt = false;
              }
              if (!isThere)
                keepIt = false;
            }
            break;
          }

          case "isNotEmpty": {
            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1190 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                // console.log("1195 - row.moduleVersion=", row.moduleVersion);

                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  // console.log("1200 -ver=", ver);
                  // console.log("1201 -det=", det);
                  // console.log("1202 -filter=", filter);

                  // console.log("1258 - ver.module_hwid == filter.columnField=", ver.module_hwid == filter.columnField);
                  // console.log("1202 - det[1]=", det[1]);
                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] === undefined || det[1] === null || det[1] === "")
                      keepIt = false;
                  }
                }
                if (!isThere)
                  keepIt = false;
              }
              else
                keepIt = false;

            }
            else if (filter.columnField === "owner") {
              if (row["email"] === '' || row["email"] === undefined || row["email"] === null)
                keepIt = false;
            }
            else {
              if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
                keepIt = false;
            }
            break;
          }

          default:
            keepIt = true;
        }
      }
    }
    else if (filterModel && linkOperator === "or") {
      keepIt = false;

      // console.log("1001 - filterModel=", filterModel);

      for (const filter of filterModel.items) {
        const values = filter.value && filter.value.split("|");

        switch (filter.operatorValue) {
          case "contains": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().includes(filter.value.toUpperCase()))
            //   keepIt = true;
            // break;

            if (filter.value) {
              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              // console.log("1230 - columnElement=", columnElement);

              if (columnElement && columnElement.moduleVersionColumn === true) {

                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {

                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');

                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;

            // if (filter.value) {

            //   const columnElement = allColumns.find((element) => {
            //     return element.field === filter.columnField;
            //   });

            //   const found = values.find(value => {
            //     // console.log("1231 - row=", row);
            //     // console.log("1232 - value=", value);
            //     // row[filter.columnField].toUpperCase().includes(value.toUpperCase())

            //     console.log("998 - value=", value);
            //     for (const ver of row.moduleVersion) {
            //       let det = ver.module_name.split('-');

            //       console.log("1002 - ver=", ver);
            //       console.log("1004 - filter=", filter);
            //       console.log("1005 - det[1]=", det[1]);

            //       if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
            //         return ver;
            //       }
            //     };
            //   });
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;
          }

          case "equals": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase() === filter.value.toUpperCase())
            //   keepIt = true;
            // break;

            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase() === (value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase() === (value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase() === (value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "startsWith": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().startsWith(filter.value.toUpperCase()))
            //   keepIt = true;

            // if (filter.value && row[filter.columnField]) {
            //   const found = values.find(value =>
            //     row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
            //   )
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;

            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().startsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "endsWith": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().endsWith(filter.value.toUpperCase()))
            //   keepIt = true;

            // if (filter.value && row[filter.columnField]) {
            //   const found = values.find(value =>
            //     row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
            //   )
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;

            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().endsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "isEmpty": {
            // if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
            //   keepIt = true;

            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1082 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                /*
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');
  
                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null)
                      keepIt = false;
                  }
                };
                if (!isThere)
                  keepIt = false;
                */
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');
                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] === undefined || det[1] === null || det[1] === "")
                      keepIt = true;
                  }
                };
                if (!isThere)
                  keepIt = true;
              }

            }
            else if (filter.columnField === "owner") {
              if (row["email"] === '' || row["email"] === undefined || row["email"] === null)
                keepIt = true;
            }
            else {
              if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
                keepIt = true;
            }
            break;
          }

          case "isNotEmpty": {
            // if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
            //   keepIt = true;

            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            if (columnElement && columnElement.moduleVersionColumn === true) {

              if (row.moduleVersion && row.moduleVersion.length) {
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null && det[1] !== "")
                      keepIt = true;
                  }
                }
                if (isThere)
                  keepIt = true;
              }
            }
            else if (filter.columnField === "owner") {
              if (row["email"] !== '' && row["email"] !== undefined && row["email"] !== null)
                keepIt = true;
            }
            else {
              if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
                keepIt = true;
            }
            break;
          }

          default:
            keepIt = false;
        }
      }
    }
    return keepIt;
  });

  // console.log("1573 - licenseColumnsFromDatabase=", licenseColumnsFromDatabase);

  // console.log("1278 - activeGridFilter(t, GridFilterInputValue) }=", activeGridFilter(t, GridFilterInputValue));
  // console.log("856 - selected=", selected);
  // console.log("859 - initialSelectedLocations=", initialSelectedLocations);

  // console.log("1282 - locationColumnsFromDatabase=", locationColumnsFromDatabase);
  // console.log("1578 - allColumns=", allColumns);
  // console.log("1579 - newFilteredRows=", newFilteredRows);

  // console.log("2304 - user=", user);

  let modeLicenseText = t('admin.licenses.status.' + modeLicenses);
  let totalLicensesCount = newFilteredRows.length;

  const newNewFilteredRows = _.filter(newFilteredRows, row => {
    if (modeLicenses === 'all_licenses') {
      return true;
    }
    else if (modeLicenses === 'my_licenses') {
      if (row.Owner === user.id)
        return true;
    }
    return false;
  });

  let filteredLicensesCount = newNewFilteredRows.length;

  // console.log("1599 - newNewFilteredRows=", newNewFilteredRows);

  return (
    <div className="admin">
      <DataGridPro
        apiRef={apiRef}
        loading={loading}
        // checkboxSelection
        disableSelectionOnClick

        pageSize={settings.pageSize}
        pagination={settings.pagination}
        rows={newNewFilteredRows}
        columns={allColumns}

        onSelectionModelChange={selected => setModel({ ...model, selected })}
        columnTypes={{ activeFilter: activeGridFilter(t, GridFilterInputValue) }}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        getRowClassName={(params) => {
          return params.id === highlightedRow ? "highlight" : "";
        }}
        onRowClick={o => {
          if (o.id === highlightedRow)
            setHighlightedRow(null);
          else
            setHighlightedRow(o.id)
        }}

        onRowDoubleClick={o => {
          const r = newNewFilteredRows.find((rowElement) => {
            return rowElement.id === o.id;
          });

          if (r) {
            let forceDisabled = false;
            if (r.Owner !== null && user.roleId >= roles.stAdmin) {
              forceDisabled = true;
              if (r.Owner === user.id)
                forceDisabled = false;
            }
            if (!forceDisabled /*&& r.exists && r.enabled*/)
              setSelectedLicense(r);
          }
        }}

        onColumnWidthChange={(params, event) => {
          changeColumnsWidth(params);
        }}
        onColumnVisibilityChange={(params, event) => {
          changeColumnsVisibility(params);
        }}
        onColumnOrderChange={(params, event) => {
          if (oldIndex === null) {
            setReorderedColumn(params.field)
            setOldIndex(params.oldIndex);
          }
          setTargetIndex(params.targetIndex);
        }}

        sortModel={sortModel}
        onSortModelChange={(model) => handleSortChange(model)}

        //filterMode="server"
        filterModel={filterModel}

        onFilterModelChange={(model) => {
          // console.log('1368 - model=', model);
          setFilterModel(model);
        }}
        disableAddFilterButton={false}

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        components={{
          ColumnMenu: CustomColumnMenu,
          ColumnSortedAscendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_upward
            </div>
          ),
          ColumnSortedDescendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_downward
            </div>
          ),
          ColumnUnsortedIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks, opacity: '0.4' }}
            >
              remove
            </div>
          ),
          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">
              <h2>
                {/* {t('admin.licenses.title')} */}
                <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                  <ul className="dropdown__list" id="modeLicenses" style={{ fontSize: "15px" }}>
                    <li
                      onClick={() => handleSetModeLicenses('all_licenses')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.licenses.status.all_licenses')}
                    </li>

                    <li
                      onClick={() => handleSetModeLicenses('my_licenses')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.licenses.status.my_licenses')}
                    </li>

                  </ul>

                  <h2
                    className="dropdown__content"
                    style={{
                      display: "flex",
                      position: "relative",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "0px",
                      marging: "0px 0px 8px 0px",
                      transition: "0.25s",
                      userSelect: "none",
                      textAlign: 'center'
                    }}
                    onClick={() => document.querySelector('#modeLicenses').classList.toggle('open')}
                  >
                    <span className="dropdown__open"> </span>
                    <span className="dropdown__open">{modeLicenseText}</span>
                    <span
                      className="dropdown__open material-icons-round dropdown__arrow"
                      style={{ padding: "4px 0px 0px 0px" }}
                    >
                      expand_more
                    </span>
                  </h2>
                </div>

                {'\u2000\u2000'}
                <span style={{ color: colors.softthinks, padding: "0px 0px 0px 0px" }}>
                  {loading ? (t('global.loading') + '...') : ((modeLicenses === 'all_licenses') ? '(' + totalLicensesCount + ')' : '(' + filteredLicensesCount + '/' + totalLicensesCount + ')'  /*apiRef.current.getVisibleRowModels().size*/)}
                </span>
              </h2>

              <div className="options">
                <GridToolbarContainer>
                  <GridToolbarFilterButton />
                  <GridToolbarColumnsButton />
                </GridToolbarContainer>
                <span className="separation" />

                <div className="actions">
                  <Export
                    apiRef={apiRef}
                    loading={loading}
                    model={model}
                    setModel={setModel}
                  /> {/* Excel / PDF Download */}

                  <button title={t('global.actions.print')} className="button icon" onClick={updateRowsAndPrint} disabled={loading}>
                    <span className="material-icons-round">print</span> {/* Print */}
                  </button>
                </div>
                <span className="separation" />

                <Button
                  className="button"
                  onClick={() => setSelectedLicense({})}
                  startIcon={<span className="material-icons-round">add_circle_outline</span>}
                >{t('admin.licenses.create.button')}
                </Button>


                {/* <Button                             
                  className="button"
                  onClick={() => { 
                    runDebugProcedure();
                   }}
                  startIcon={<span className="material-icons-round">bug_report</span>}
                >
                  {'dEBUG'}
                </Button> */}


              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">
              <GridFooter />
              <div className="checkbox">
                <input
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                  onChange={() => changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch)}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {selectedOption()}

      {(licenses.length > 0) && <Print licenses={rowsToPrint()} />}
    </div>
  );
}
